import React from "react";

export default class ModalSintillo  extends React.Component {
    onClose = e => { 
        this.props.onClose && this.props.onClose (e); 
     }; 
    render() {
    if(!this.props.show){
        return null;
    }
  return <div className="content-padre-msjTooltip" id="tooltip">
        <div className={"msjTooltip-content"} 
            style={this.props.type === 'advertencia' ? {background:'#FBF5C6', color:'#B18931'} 
            : this.props.type === 'informativo' ? {background:'#E7F2FC', color:'#567EAD'} : 
            this.props.type === 'error' ? {background:'#F8EBED', color:'#9A4443'} : {background:'#E3F5EB', color:'#44956C'}}>
            <div className="icono-sintillo-content">
                {
                    this.props.type === 'advertencia' ? <span className="icon-warning" style={{margin:"0px"}}></span> :
                    this.props.type === 'informativo' ? <span className="icon-informativo-circulo" ></span> :
                    this.props.type === 'error' ?  <span className="icon-equis-circulo" ></span> :
                    <span className="icon-circle-dove" ></span>
                }
            </div>
            <div className="content-texto">
                <p>{this.props.titulo}</p>
                <label>{this.props.mensaje}</label>
            </div>
            <span className="material-icons icono-cerrar-sintillo" onClick={this.onClose}>close</span>
        </div>
      </div>
  }
}


// WEBPACK FOOTER //
// ./src/mensajes-tooltips/mensajes-tooltips.cmpt.js